export default "__VITE_ASSET__DetN33DS__"